import React, { useEffect, cloneElement, Fragment } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import URL from "../../../../constant/URL";
import { setLearningDataAction } from "../../../../redux/learningData";
import { setQuestionAction, clearAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { clearAnsweringInfoAction } from "../../../../redux/answeringQuestions/answeringInfo";
import { clearTimeCountAction } from "../../../../redux/answeringQuestions/timeCount";
import { clearQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";
import Logger from "./Logger";
import Closer from "./Closer";
import AccuracyLabelChanger from "./AccuracyLabelChanger";
import Timer from "./Timer";
import Viewer from "../../learning/container/Viewer";
import QuestionTipHider from "../../learning/container/QuestionTipHider";
import CorrectAnswerDevelop from "../../learning/container/CorrectAnswerDevelop";
import ScribbleCleaner from "../../learning/container/ScribbleCleaner";
import ScribbleErase from "../../learning/container/ScribbleErase";
import GrammarReducer from "../../learning/container/GrammarReducer";
import Scribbler from "../../learning/container/Scribbler";
import KeypadShower from "../../learning/container/KeypadShower";
import Inputer from "../../learning/container/Inputer";
import KeyPresser from "../../learning/container/KeyPresser";
import KeyClicker from "../../learning/container/KeyClicker";
import NoteTaker from "../../learning/container/NoteTaker";
import AnswerEditorController from "../../learning/container/AnswerEditorController";
import Submitter from "./Submitter";
import QuestionPassor from "./QuestionPassor";
import ScribbleTooltipHider from "../../learning/container/ScribbleTooltipHider";
import NotEnteredAnswerChecker from "./NotEnteredAnswerChecker";
import { setQuestionData } from "../../../../redux/amplitude";

const AnsweringAIDiagnosisInitializer = ( props ) => {

  const history = useHistory();
  const location = useLocation();

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setLearningData = payload => { dispatch( setLearningDataAction( payload ) ) };
  const setQuestion = payload => { dispatch( setQuestionAction( payload ) ) };
  const clearAnsweringQuestions = () => { dispatch( clearAnsweringQuestionsAction() ) };
  const clearAnsweringInfo = () => { dispatch( clearAnsweringInfoAction() ) };
  const clearTimeCount = () => { dispatch( clearTimeCountAction() ) };
  const clearQuestionView = () => { dispatch( clearQuestionViewAction() ) };

  useEffect( () => {
    setTimeout( () => {
      setLearningData( { answeringQuestionsComplete : false } );
      setQuestion( { data : location.state } );
    } );
    
    return async () => {
      clearAnsweringQuestions();
      clearAnsweringInfo();
      clearTimeCount();
      clearQuestionView();
    };
  }, []);

  useEffect(() => {
    dispatch(setQuestionData({...answeringQuestions?.data}));
  }, [answeringQuestions.data]);

  useEffect( () => {
    answeringQuestions.resultData.prgsCd && history.replace( URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ANALYSIS );
  }, [ answeringQuestions.resultData.prgsCd ] );

  return cloneElement( props.children || <Fragment />, {
    Logger,
    Closer,
    AccuracyLabelChanger,
    Timer,
    Viewer,
    QuestionTipHider,
    CorrectAnswerDevelop,
    ScribbleCleaner,
    ScribbleErase,
    GrammarReducer,
    Scribbler,
    KeypadShower,
    Inputer,
    KeyPresser,
    KeyClicker,
    NoteTaker,
    AnswerEditorController,
    Submitter,
    QuestionPassor,
    ScribbleTooltipHider,
    NotEnteredAnswerChecker
  } );

};

export default AnsweringAIDiagnosisInitializer;
